import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import { Card } from '../components/common/Card';
import { Badge } from '../components/common/Badge';
import { Database, Shield } from 'lucide-react';

export const SettingsView: React.FC = () => {
  const { tenant } = useAuth();
  const { subdomain } = useTenant();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '28px', maxWidth: '900px' }}>
      <div>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '6px' }}>Organization Workspace Settings</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          Manage your organization branding, database isolation details, and subscription tiers.
        </p>
      </div>

      <Card>
        <h3 style={{ fontSize: '1.125rem', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Database className="w-5 h-5" style={{ color: 'var(--brand-primary)' }} />
          Database Isolation Profile
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', fontSize: '0.875rem' }}>
          <div>
            <span style={{ color: 'var(--text-muted)', display: 'block', fontSize: '0.75rem', marginBottom: '4px' }}>
              Tenant Identifier
            </span>
            <code style={{ color: '#a5b4fc', fontFamily: 'var(--font-mono)' }}>{tenant?.tenantId}</code>
          </div>
          <div>
            <span style={{ color: 'var(--text-muted)', display: 'block', fontSize: '0.75rem', marginBottom: '4px' }}>
              Isolated DB Logical Name
            </span>
            <code style={{ color: '#a5b4fc', fontFamily: 'var(--font-mono)' }}>tenant_{subdomain}_db</code>
          </div>
          <div>
            <span style={{ color: 'var(--text-muted)', display: 'block', fontSize: '0.75rem', marginBottom: '4px' }}>
              Subdomain Host Routing
            </span>
            <span style={{ fontWeight: 600 }}>{subdomain}.saasapp.com</span>
          </div>
          <div>
            <span style={{ color: 'var(--text-muted)', display: 'block', fontSize: '0.75rem', marginBottom: '4px' }}>
              Current Subscription Tier
            </span>
            <Badge variant="primary" style={{ textTransform: 'capitalize' }}>
              {tenant?.tier || 'Enterprise'}
            </Badge>
          </div>
        </div>
      </Card>

      <Card>
        <h3 style={{ fontSize: '1.125rem', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Shield className="w-5 h-5" style={{ color: 'var(--color-success)' }} />
          Data Security & Compliance
        </h3>
        <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
          <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: 'var(--color-success)' }}>✓</span>
            Physical database isolation ensures zero co-mingling of tenant data.
          </li>
          <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: 'var(--color-success)' }}>✓</span>
            Central Analytics pipeline receives only de-identified, non-PII operational counters.
          </li>
          <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: 'var(--color-success)' }}>✓</span>
            All database connections are dynamically pooled and cached with idle garbage collection.
          </li>
        </ul>
      </Card>
    </div>
  );
};
